<template>
  <div>
    <slot></slot>
    <div ref="turnstileContainer" class="turnstile-container"></div>
  </div>
</template>

<script>
const env = window.env || process.env

const SITE_KEY = env.VUE_APP_TURNSTILE_SITE_KEY || '1x00000000000000000000AA'

function loadTurnstileScript() {
  return new Promise(function(resolve) {
    if (window.turnstile) {
      resolve()
      return
    }

    var existing = document.querySelector(
      'script[src*="challenges.cloudflare.com/turnstile"]'
    )
    if (existing) {
      existing.addEventListener('load', resolve)
      return
    }

    var script = document.createElement('script')
    script.src =
      'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
    script.async = true
    script.defer = true
    script.onload = resolve
    document.head.appendChild(script)
  })
}

export default {
  data: function() {
    return {
      widgetId: null,
      _loadTimeout: null,
      _turnstileReady: false,
    }
  },

  mounted: function() {
    this.renderWidget()
    this._startFallbackTimeout()
  },

  beforeDestroy: function() {
    this._clearFallbackTimeout()
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId)
    }
  },

  methods: {
    _startFallbackTimeout: function() {
      var self = this
      this._loadTimeout = setTimeout(function() {
        if (!self._turnstileReady) {
          self.$emit('verify', '')
        }
      }, 10000)
    },

    _clearFallbackTimeout: function() {
      if (this._loadTimeout) {
        clearTimeout(this._loadTimeout)
        this._loadTimeout = null
      }
    },

    renderWidget: function() {
      var self = this
      loadTurnstileScript().then(function() {
        if (!window.turnstile || !self.$refs.turnstileContainer) return

        self._turnstileReady = true
        self._clearFallbackTimeout()

        self.widgetId = window.turnstile.render(self.$refs.turnstileContainer, {
          sitekey: SITE_KEY,
          callback: function(token) {
            self.$emit('verify', token)
          },
          'error-callback': function() {
            self.$emit('error')
          },
          size: 'flexible',
          execution: 'execute',
          theme: 'light',
        })
      })
    },

    execute: function() {
      if (this._turnstileReady && this.widgetId !== null && window.turnstile) {
        window.turnstile.execute(this.widgetId)
      } else {
        this.$emit('verify', '')
      }
    },

    resetRecaptcha: function() {
      if (this.widgetId !== null && window.turnstile) {
        window.turnstile.reset(this.widgetId)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.turnstile-container {
  display: flex;
  justify-content: center;
}
</style>
